export default function SectionHeader({ eyebrow, title, intro, align = "left" }) {
  const alignCls =
    align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="h-display-2 text-[#2A0A0E] mt-4">{title}</h2>
      {intro && (
        <p className="mt-5 text-slate-600/65 text-base sm:text-lg leading-relaxed max-w-2xl">
          {intro}
        </p>
      )}
    </div>
  );
}
